import { Component, Input, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { ConfigService } from '@services/webFeeder/config.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subscription , of } from 'rxjs';
import { AuthServer } from '@services/auth-server.service';
import { DatePipe } from '@angular/common';
import { SideEnum } from '@model/enum/side.enum';
import { MarketEnum } from '@model/enum/market.enum';

@Component({
  selector: Constants.WINDOW_NAME_VOLUME_AT_PRICE,
  templateUrl: './volume-at-price.component.html'
})

export class VolumeAtPriceComponent extends AbstractItem implements OnInit, OnDestroy {

  @Input() override data: any;
  symbol: string;
  messageQuote = new MessageQuote();
  rowOffersData: any[] = [];
  windowActive: any;
  newWindow: boolean;
  loading = false;
  lastTrade: any;
  variation: any;
  coinVariation: number;
  period: any;
  low: number;
  high: number;
  open: number;
  previous: number;
  adjustment: number;
  percentageBuy: number;
  percentageSell: number;
  classPressure = '';
  last;
  periodValue = 0;
  classBarVolumeWidthOfBuyer: any;
  classBarVolumeWidthOfSeller: any;
  classBarVolumeWidthOfDirect: any;
  classBarVolumeWidthOfUndetermined: any;
  showExpandCard = this._configService.getShowExpandCard(Constants.WINDOW_NAME_VOLUME_AT_PRICE);
  volumeBuy = 0;
  volumeSell = 0;
  hiddenInvalid: boolean;
  private _subscriptionQuote: Subscription;
  override dialog: MatDialog;
  msgNoData = Constants.WORKSPACE_MSG018;
  maxVolume = 0;
  company: string;
  oldSymbolTemp: string;
  protected override workspaceService: WorkspaceNewService;
  timeUpdate: any;
  isGetVap: boolean;
  showEmpty: boolean;
  auctionHammer: boolean;
  showVariation: boolean;
  isUpdateOnDemand: boolean;
  imgName: any;
  loadingImgName: boolean;
  isThemeDark: any;
  subscripitionChangeThemeDarkLight: Subscription;
  @ViewChild('scrollableDiv') scrollableDiv: ElementRef;
  timeoutWhiteLabel: any;
  whiteLabel: any;
  classPressureBuy: string;
  classPressureSell: string;
  intervalId: any;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  firstLoad: boolean;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;

  constructor(
    private _quoteService: QuoteService,
    private _route: ActivatedRoute,
    workspaceService: WorkspaceNewService,
    itemService: AbstractItemService,
    dialog: MatDialog,
    public _NotificationService: NotificationsService,
    private _authServer: AuthServer,
    private datePipe: DatePipe,
    private _configService: ConfigService
  ) {
    super(workspaceService, dialog, itemService);
    this.workspaceService = workspaceService;
    this.dialog = dialog;
    this.period = new Array();
    this.period.push({ description: 'DIA', value: 0, selected: true });
    this.period.push({ description: '60M', value: 60, selected: false });
    this.period.push({ description: '30M', value: 30, selected: false });
    this.period.push({ description: '15M', value: 15, selected: false });
    this.period.push({ description: '10M', value: 10, selected: false });
    this.period.push({ description: '5M', value: 5, selected: false });
    this.period.push({ description: '1M', value: 1, selected: false });
  }

  ngOnInit() {
    this.subscripitionChangeThemeDarkLight = this._configService.changeThemeDarkLight$
      .subscribe(x => {
        if (x === 1) {
          this.isThemeDark = true;
        } else {
          this.isThemeDark = false;
        }
        this.getConfigWhiteLabel();
      });
    this.isThemeDark = this._configService.getFavoriteThemeUser();
    this.whiteLabel = this._configService.getConfigWhitelabel();
    this.firstLoad = true;
    this.getConfigWhiteLabel();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.unsubscribeQuote();
    this.closeSheet();
    if (this.subscripitionChangeThemeDarkLight) {
      this.subscripitionChangeThemeDarkLight.unsubscribe();
    }
  }

  getConfigWhiteLabel() {
    if (this.whiteLabel) {
      this.classPressureBuy = this._configService.getPressureBarColor(SideEnum.BUY);
      this.classPressureSell = this._configService.getPressureBarColor(SideEnum.SELL);
      this.classPressure = `linear-gradient(90deg, ${this.classPressureBuy} 45%, ${this.classPressureSell} 55%)`;
    }
    if (this.data && this.data.symbol) {
      this.symbol = this.data.symbol;
      this.setQuote(this.data.symbol);
    } else {
      this._route.queryParams.subscribe(params => {
        if (params['symbol']) {
          this.symbol = params['symbol'];
          this.setQuote(this.symbol);
          this.newWindow = true;
        }
      });
    }
  }

  getVap(symbol: string, marketType: number, isUpdate?: boolean) {
    if (symbol && (marketType === 1 || marketType === 3)) {
      if (!isUpdate) {
        this.loading = true;
      }
      this._authServer.iQuote.getVolumeAtPrice(this.symbol, this.periodValue)
        .subscribe(data => {
          if (data && data.values && data.values.length > 0) {
            this.rowOffersData = data.values;
            this.volumeSell = 0;
            this.volumeBuy = 0;
            this.rowOffersData.forEach((item, index) => {
              this.volumeSell += Number(this.rowOffersData[index].volumeSell);
              this.volumeBuy += Number(this.rowOffersData[index].volumeBuy);
              this.rowOffersData[index].price = AppUtils.convertNumberToCurrency(Number(this.rowOffersData[index].price), this.messageQuote.tickSize ? this.messageQuote.tickSize : 2);
              this.rowOffersData[index].class = this.getCssForPrice(this.rowOffersData[index].price);
              this.rowOffersData[index].tooltipTitle = this.getTooltipTitle(this.rowOffersData[index].price);
              if (this.rowOffersData[index].price && this.rowOffersData[index].price.split(',')[1] === '00') {
                this.rowOffersData[index].price = this.rowOffersData[index].price.split(',')[0];
              }
            });
            this.calculateWidthOfBarVolume();
            AppUtils.orderObjectDesc(this.rowOffersData, 'price');
          }
          this.timeUpdate = this.datePipe.transform(new Date(), Constants.DATE_UPDATE_VOLUME);
          this.showEmpty = false;
          this.loading = false;
          this.calculatePressure();
          this.focusOnLastValue();
        });
    } else {
      this.showEmpty = true;
      this.loading = false;
    }
  }

  focusOnLastValue() {
    setTimeout(() => {
      if (this.scrollableDiv) {
        this.rowOffersData.map((item, index) => {
          if (item.price.trim() == this.lastTrade) {
            const itemIndex = index;
            const lineHeigth = this.scrollableDiv.nativeElement.scrollHeight / this.rowOffersData.length;
            this.scrollableDiv.nativeElement.scrollTo(0, ((itemIndex - 4) * lineHeigth));
          }
        });
      }
    }, 50);
  }

  selectAsset(event) {
    if (this.data) {
      this.data.symbol = event.symbol;
    }
    this.resetQuote();
    if (this.data.symbol) {
      this.setQuote(event.symbol);
    } else if (this.data.symbol === '') {
      if (this.oldSymbolTemp !== undefined) {
        super.updateOnDemand(this.symbol, this.data.symbol, false);
      }
      this.oldSymbolTemp = undefined;
    }

  }

  setQuote(symbol: string) {
    const oldSymbol = this.symbol ? this.symbol : '';
    this.oldSymbolTemp = oldSymbol;
    symbol = AppUtils.trimStart(symbol);
    this.symbol = symbol;
    if (this.symbol && this.symbol !== '') {
      this.subscribeQuote();
    }
  }

  openNewWindow() {
    if (this.data.symbol) {
      const options = 'width=300px, height=498px';
      const parameters = '?symbol=' + this.symbol;
      if (this.windowActive == null || this.windowActive.closed) {
        super.getNewWindow('volume-at-price', parameters, options, this.data.id).subscribe(window => {
          this.windowActive = window;
        });
      } else {
        this.windowActive.focus();
      }
    } else {
      this._NotificationService.warn('', Constants.WORKSPACE_MSG025);
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  resetQuote() {
    if (!this.symbol) {
      return;
    }

    const oldSymbol = this.symbol;
    if (this.data && oldSymbol.toLowerCase() === this.data.symbol.toLowerCase()) {
      return;
    }
    // else if (this.data && super.validateOnlyOneAssetAssigned(this.data.symbol, this.data.type, this.data.workspaceId) === true) {
    //   this._NotificationService.error('Erro', Constants.WORKSPACE_MSG015);
    //   this.symbol = '';
    //   super.updateOnDemand(oldSymbol, this.symbol, true);
    //   setTimeout(() => {
    //     this.symbol = oldSymbol;
    //   }, 0);
    //   return;
    // }
    this.unsubscribeQuote();
    this.imgName = '';
    this.company = '';
    this.lastTrade = null;
    this.variation = null;
    this.coinVariation = null;
    this.volumeSell = 0;
    this.volumeBuy = 0;
    this.rowOffersData = [];
    this.symbol = '';
    this.timeUpdate = null;
    this.calculatePressure();
    this.messageQuote = new MessageQuote();
    clearInterval(this.intervalId);
  }

  onChangePeriod(item) {
    if (this.periodValue === item.value) {
      return;
    }
    this.loading = true;
    this.periodValue = item.value;
    for (let i = 0; i < this.period.length; i++) {
      if (this.period[i].value === item.value) {
        this.period[i].selected = true;
      } else {
        this.period[i].selected = false;
      }
    }
    this.getVap(this.messageQuote.symbol, this.messageQuote.marketType, true);
    this.updateVapInterval();
  }

  getCssForPrice(value) {
    value = value.trim().replace('.', '').replace(',', '.');
    value = AppUtils.convertNumberToCurrency(
      Number(value),
      this.messageQuote && this.messageQuote.tickSize ? this.messageQuote.tickSize : 2
    );
    if (value === this.lastTrade) {
      return 'price-current-color';
    }

    if (value === this.high) {
      return 'price-high-color';
    }

    if (value === this.low) {
      return 'price-low-color';
    }

    if (value === this.open) {
      return 'price-open-color';
    }

    if (value === this.previous) {
      return 'price-close-color';
    }

    if (value === this.adjustment) {
      return 'price-adjustment-color';
    }
  }

  getTooltipTitle(value) {
    value = value.trim().replace('.', '').replace(',', '.');
    value = AppUtils.convertNumberToCurrency(
      Number(value),
      this.messageQuote && this.messageQuote.tickSize ? this.messageQuote.tickSize : 2
    );
    if (value === this.lastTrade) {
      return 'Preço atual';
    }

    if (value === this.high) {
      return 'Preço máximo';
    }

    if (value === this.low) {
      return 'Preço mínimo';
    }

    if (value === this.open) {
      return 'Preço de abertura';
    }

    if (value === this.previous) {
      return 'Preço de fechamento';
    }

    if (value === this.adjustment) {
      return 'Preço de Ajuste';
    }
  }

  private unsubscribeQuote() {
    if (this._quoteService) {
      this._quoteService.unsubscribeQuote(this.symbol, Constants.WINDOW_NAME_VOLUME_AT_PRICE);
    }
    if (this._subscriptionQuote) {
      this._subscriptionQuote.unsubscribe();
    }
  }

  private subscribeQuote() {
    if (this.oldSymbolTemp && this.symbol && this.oldSymbolTemp.toLowerCase() === this.symbol.toLowerCase() && this._subscriptionQuote) {
      return;
    }
    if (this.symbol.toLowerCase() === 'invalid') {
      this.hiddenInvalid = true;
      this.resetQuote();
      this.symbol = '';
      return;
    }
    const msgItem = this._quoteService.subscribeQuote(this.symbol, Constants.WINDOW_NAME_VOLUME_AT_PRICE);
    if (msgItem !== undefined && msgItem !== '') {
      this.resetQuote();
      return;
    }
    this.isUpdateOnDemand = false;
    this.isGetVap = false;
    this.loadingImgName = true;
    const _VolumeAtPriceInstance = this;
    this._subscriptionQuote = this._quoteService.messagesQuote
      .subscribe((msg: MessageQuote) => {
        if (msg && msg.errorMessage && (this.symbol && msg.symbol && msg.symbol.toLowerCase() === this.symbol.toLowerCase())) {
          this.hiddenInvalid = true;
          this.symbol = null;
          this.company = null;
          this.imgName = '';
          if (Constants.WORKSPACE_MSG030 && msg.symbol && _VolumeAtPriceInstance.firstLoad) {
            _VolumeAtPriceInstance.firstLoad = false;
            const messageShow = Constants.WORKSPACE_MSG030.replace('{{quote}}', msg.symbol.toUpperCase()).replace('{{card}}', Constants.TITLE_CARD_VOLUME_AT_PRICE);
            this._NotificationService.warn('', messageShow);
          }
          this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), Constants.WINDOW_NAME_VOLUME_AT_PRICE);
        } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
          _VolumeAtPriceInstance.firstLoad = false;
          if (this.loadingImgName) {
            this.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(this.symbol, msg.marketType).toUpperCase() + '.PNG';
            this.loadingImgName = false;
          }
          this.messageQuote = msg;
          if (!this.isUpdateOnDemand) {
            this.isUpdateOnDemand = true;
            if (!this.newWindow) {
              super.updateOnDemand(this.oldSymbolTemp, this.symbol);
            }
          }
          if (!this.isGetVap) {
            this.isGetVap = true;
            this.getVap(this.messageQuote.symbol, this.messageQuote.marketType);
            this.updateVapInterval();
          }
          this.hiddenInvalid = false;
          if (msg.theoryPrice && (msg.theoryPrice > 0 || (msg.theoryPrice.toString() !== '-' && Number(msg.theoryPrice.toString().replace(',', '.'))))) {
            this.priceTheory = AppUtils.convertBrCurrencyToNumber(msg.theoryPrice.toString(), ',');
            this.auctionHammer = true;
            this.timeToOpen = msg.timeToOpen;
            let previousConst = 0;
            if (msg.previous && (msg.previous.toString() !== '-' || msg.previous.toString() !== '0,00' || msg.previous.toString() !== '0')) {
              previousConst = AppUtils.convertBrCurrencyToNumber(msg.previous.toString(), ',');
            }
            if (this.priceTheory > 0 && previousConst > 0) {
              let varTheoryTemp = ((this.priceTheory / previousConst) - 1) * 100;
              if (varTheoryTemp !== 0) {
                varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
              }
            }
          } else {
            this.priceTheory = 0;
            this.varTheory = null;
            this.timeToOpen = null;
            this.auctionHammer = false;
          }
          if (msg.lastTrade && (msg.lastTrade.toString() === '-' || msg.lastTrade.toString() === '0,00' || msg.lastTrade.toString() === '0')) {
            this.showVariation = false;
            msg.lastTrade = msg.previous;
          }
          if (msg.dateLastNegotiation) {
            const today = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
            if (today === msg.dateLastNegotiation) {
              this.showVariation = true;
            } else {
              this.showVariation = false;
            }
          } else {
            this.showVariation = true;
          }

          if (this.messageQuote.errorMessage !== undefined && this.messageQuote.errorMessage !== '') {
            this.resetQuote();
          } else {
            this.loadMessageQuote();
          }
          if (msg.description && msg.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
            this.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
          } else {
            this.company = this.messageQuote.description;
          }
        }
      }
      );
  }

  private loadMessageQuote() {
    this.last = this.lastTrade;
    if (this.messageQuote.lastTrade && this.messageQuote.lastTrade.toString() === '-') {
      this.messageQuote.lastTrade = this.messageQuote.previous;
    }
    const tickSize = this.messageQuote.marketType !== MarketEnum.BITCOIN
      ? this.messageQuote.tickSize
      : 3;
    if (this.messageQuote.lastTrade) {
      const lasTradeNumber = AppUtils.convertFormattedNumberToNumber(this.messageQuote.lastTrade);
      this.lastTrade = AppUtils.convertNumberToCurrency(lasTradeNumber, tickSize);
    }
    this.variation = this.messageQuote.variation;
    this.coinVariation = this.messageQuote.coinVariation && this.messageQuote.coinVariation.toString() !== '-'
      ? Number(this.messageQuote.coinVariation.toString().replace(',', '.')) : 0.0;
    this.low = this.messageQuote.low;
    this.high = this.messageQuote.high;
    this.open = this.messageQuote.open;
    this.adjustment = this.messageQuote.adjustment;
    this.previous = this.messageQuote.previous;
  }

  private calculateWidthOfBarVolume() {
    let left = 0;
    this.maxVolume = 0;
    for (let i = 0; i < this.rowOffersData.length; i++) {
      let totalVol = 0;
      const volumeBuy = this.rowOffersData[i].volumeBuy ?
        AppUtils.convertBrCurrencyToNumber(this.rowOffersData[i].volumeBuy, ',') : 0;
      const volumeSell = this.rowOffersData[i].volumeSell ?
        AppUtils.convertBrCurrencyToNumber(this.rowOffersData[i].volumeSell, ',') : 0;
      const volumeDirect = this.rowOffersData[i].volumeDirect ?
        AppUtils.convertBrCurrencyToNumber(this.rowOffersData[i].volumeDirect, ',') : 0;
      const volumeUndefined = this.rowOffersData[i].volumeUndefined ?
        AppUtils.convertBrCurrencyToNumber(this.rowOffersData[i].volumeUndefined, ',') : 0;
      totalVol = volumeBuy + volumeSell + volumeDirect + volumeUndefined;

      let balance = 0;
      balance = volumeBuy - volumeSell;

      this.rowOffersData[i].totalVolumeUnformatted = totalVol;
      this.rowOffersData[i].totalVolume = AppUtils.convertNumberToOptimizedNumber(totalVol);
      this.rowOffersData[i].balance = balance;

      left = 0;
      // Buyer
      const barVolumeBuyerPerc = (volumeBuy * 100) / totalVol;
      this.rowOffersData[i]['classBarVolumeWidthOfBuyer'] = { 'width': barVolumeBuyerPerc + '%', 'left': left + '%' };
      left += barVolumeBuyerPerc;

      // Seller
      const barVolumeSellerPerc = (volumeSell * 100) / totalVol;
      this.rowOffersData[i]['classBarVolumeWidthOfSeller'] = { 'width': barVolumeSellerPerc + '%', 'left': left + '%' };
      left += barVolumeSellerPerc;

      // Direct
      const barVolumeDirectPerc = (volumeDirect * 100) / totalVol;
      this.rowOffersData[i]['classBarVolumeWidthOfDirect'] = { 'width': barVolumeDirectPerc + '%', 'left': left + '%' };
      left += barVolumeDirectPerc;

      // Undetermined
      const barVolumeUndeterPerc = (volumeUndefined * 100) / totalVol;
      this.rowOffersData[i]['classBarVolumeWidthOfUndetermined'] = { 'width': barVolumeUndeterPerc + '%', 'left': left + '%' };
      if (this.rowOffersData[i].totalVolumeUnformatted !== undefined && this.rowOffersData[i].totalVolumeUnformatted > this.maxVolume) {
        this.maxVolume = this.rowOffersData[i].totalVolumeUnformatted;
      }
    }
  }

  private calculatePressure() {
    if (this.volumeBuy && this.volumeSell) {
      const totalValue = this.volumeBuy + this.volumeSell;
      this.percentageBuy = ((this.volumeBuy * 100) / totalValue);
      this.percentageSell = ((this.volumeSell * 100) / totalValue);
      this.classPressure = `linear-gradient(90deg, ${this.classPressureBuy} ${this.percentageBuy.toFixed(2)}%, ${this.classPressureSell} ${((this.percentageBuy + 10).toFixed(2))}%)`;
    } else {
      this.classPressure = `linear-gradient(90deg, ${this.classPressureBuy} 45%, ${this.classPressureSell} 55%)`;
      this.percentageBuy = undefined;
      this.percentageSell = undefined;
    }
  }

  private updateVapInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      if (this.messageQuote.symbol && (this.messageQuote.marketType === 1 || this.messageQuote.marketType === 3)) {
        this.getVap(this.messageQuote.symbol, this.messageQuote.marketType, true);
      } else {
        clearInterval(this.intervalId);
      }
    }, Constants.INTERVAL_VOLUME_AT_PRICE);
  }
}
